// extracted by mini-css-extract-plugin
export default {"image":"pY-z","loaded":"qY-z"};